<script>
    import SearchByFilters from '../MrMovie/SearchByFilters';
    import StoredFilters from '../MrMovie/StoredFilters';

    export default {
        props: {
            // 'desktop' or 'mobile'
            viewType: {
                type: String,
                default: 'desktop',
            },
            // 'movie' or 'cinema'
            pageFilterType: {
                type: String,
                required: true,
            },
            id: {
                type: String,
                default: '',
            },
            // A prefix to make element IDs unique
            idPrefix: {
                type: String,
                default: '',
            },
            icon: {
                type: String,
            },
            plural: {
                type: String,
                required: true,
            },
            inputName: {
                type: String,
                required: true,
            },
            // Selectable items, as {value, label} objects
            items: {
                type: Array,
                default: [],
            },
            // The amount of items after which to show a 'more' toggle button
            moreBreakpoint: {
                type: Number,
                default: 6,
            },
            showFilterLabel: {
                type: Boolean,
                default: true
            },
            parentId: {
                type: String,
                default: null,
            },
            parentFilterId: {
                type: String,
                default: null,
            },
            allowSearch: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                viewTypeValue: this.viewType,
                eventName: this.pageFilterType + '_filter',
                selectableItems: this.items,
                selectedItemsString: this.plural,
                selectedItemsSubString: '',
                // Contains all the selected checkboxes (true / false)
                selected: {},
                isPageFilterContentVisible: false,
                isLocked: MrMovie.filtersLocker.isLocked(),
                searchByFilters: null,
                userTrigger: false,
                cinemaDistances: [],
                search: ''
            };
        },
        mounted() {
            this.updateSelectedItemsString();

            // // Update the filter disabled state according to the locked state
            VueEvents.$on('filters_locked', state => {
                MrMovie.filtersLocker.setLocked(state);
                this.isLocked = state;
            });

            VueEvents.$on('loaded_filters', filters => {
                this.selected = {};
                if(this.parentFilterId) {

                    if(typeof filters[this.parentFilterId] !== 'undefined') {
                        this.setSelectedItemsFromFilters(filters);
                        this.setItems(this.items);
                    }

                } else {
                    if(typeof filters[this.id] !== 'undefined') {
                        this.setItems(filters[this.id].values);
                    }
                }
                this.updateSelectedItemsString();

            });

            if(this.id === 'cinema') {
                this.cinemaDistances = MrMovie.cinemaDistances.get();
                VueEvents.$on('location-filter:cinema_distances', cinemaDistances => {
                    this.cinemaDistances = cinemaDistances;
                });
            }
            //
            // // Unlock the filters when new data arrives
            // VueEvents.$on(this.eventName + ':update', () => {
            //     VueEvents.$emit('filters_locked', false);
            // });
            //
            // // Create the search object, for listening to updates and getting data from
            // if (this.searchByFilters === null) {
            //     if (this.pageFilterType === 'movie') {
            //         this.searchByFilters = new SearchByFilters(this.eventName, '/ajax/movies');
            //     } else if (this.pageFilterType === 'cinema') {
            //         this.searchByFilters = new SearchByFilters(this.eventName, '/ajax/cinemas');
            //     }
            //
            //     this.searchByFilters.listenForChangeEvents();
            // }

            // this.searchByFilters.increaseFilterCount();

            //this.applyStoredFilters();
            //this.emitSelectedItems();
        },
        created() {
            this.setSelectedFromItems();
        },
        computed:
            {
                filteredItems:function()
                {
                    var self = this;
                    if(this.selectableItems.length && this.search.length >= 3) {
                        return this.selectableItems.filter(function(item){
                            return item.label.toLowerCase().indexOf(self.search.toLowerCase())>=0;
                        });
                    }
                    return this.selectableItems;
                }
            },
        methods: {
            /**
             * Update the state of the checkboxes
             * @param {Boolean} checked Whether to make them checked or not
             * @return {void}
             */
            setCheckboxesState(checked) {
                $.each(this.selected, (value, status) => {
                    this.selected[value] = checked;
                });
            },

            /**
             * Set the items to choose from
             * @param {Array} items
             * @return {void}
             */
            setSelectableItems(items) {
                this.selectableItems = items;
            },
            /**
             * Update the text that shows all selected items
             * @return {void}
             */
            updateSelectedItemsString() {
                let selectedValues = this.getSelectedValues();
                let selectedItemsString = '';
                let selectedItemsSubString = '';

                // Set the selected items text
                if (selectedValues.length === 0) {
                    selectedItemsString = this.plural;
                } else if (selectedValues.length === 1) {
                    for (let i=0; i<this.selectableItems.length; i++) {
                        // Use the label of the only checked checkbox
                        const selectableItem = this.selectableItems[i];
                        if (selectableItem.id === selectedValues[0]) {
                            selectedItemsString = selectableItem.label;
                            break;
                        }
                    }
                } else {
                    selectedItemsString = selectedValues.length + ' ' + this.plural.toLowerCase();

                    if(selectedValues.length) {
                        for(let selectedValue of selectedValues) {
                            for(let selectableItem of this.selectableItems) {
                                if(selectedValue === selectableItem.id) {
                                    if('' !== selectedItemsSubString) {
                                        selectedItemsSubString += ', ';
                                    }
                                    selectedItemsSubString += selectableItem.label;
                                    break;
                                }
                            }
                        }
                    }

                }
                this.selectedItemsString = selectedItemsString;
                this.selectedItemsSubString = selectedItemsSubString;
                //VueEvents.$emit(this.pageFilterType + '-' + this.inputName + ':update', selectedItemsString);
            },

            setSelected(id, children = []) {


                if(this.selected[id] === true) {
                    if(children && children.values.length) {
                        let childrenValues = [];
                        for(let childValue of children.values) {
                            childrenValues.push(childValue.id)
                        }
                        MrMovie.pageFilter.addFilters(children.id, childrenValues);
                    }

                    if(this.parentId) {
                        MrMovie.pageFilter.addFilters(this.parentFilterId, [this.parentId]);
                    }
                    MrMovie.pageFilter.addFilters(this.id, [id]);
                } else {
                    MrMovie.pageFilter.removeFilters(this.id, [id]);
                    if(children && children.values.length) {
                        let childrenValues = [];
                        for(let childValue of children.values) {
                            childrenValues.push(childValue.id)
                        }
                        MrMovie.pageFilter.removeFilters(children.id, childrenValues);
                    }
                }

                MrMovie.pageFilter.updateQueryParams();
                MrMovie.pageFilter.filter();
                this.updateSelectedItemsString();
            },

            removeFilters(id) {
                MrMovie.pageFilter.removeFilters(id);
                MrMovie.pageFilter.updateQueryParams();
                MrMovie.pageFilter.filter();
            },

            setSelectedItemsFromFilters(filters) {
                for (let item of this.items) {
                    if(typeof filters[this.id] !== 'undefined') {
                        for (let filter of filters[this.id].values) {

                            if (filter.id === item.id) {
                                item.selected = filter.selected;
                            }
                        }
                    }

                }
            },

            setItems(items) {

                this.setSelectableItems(items);
                this.setSelectedFromItems();
            },

            setSelectedFromItems()
            {
                for(let filterValueItem of this.selectableItems) {
                    if(filterValueItem.selected === true) {
                        this.selected[filterValueItem.id] = true;
                    }
                }
            },

            /**
             * Emit the values of selected items
             * @return {void}
             */
            emitSelectedItems() {
                // Lock the filters on change
                VueEvents.$emit('filters_locked', true);

                // Use a timeout, because the changed selected values don't seem to be immediate
                setTimeout(() => {
                    // Set the selected items string
                    const selectedValues = this.getSelectedValues();
                    this.updateSelectedItemsString();

                    VueEvents.$emit(this.eventName + ':changed', {
                        type: this.inputName,
                        values: selectedValues,
                    });

                    VueEvents.$emit(this.inputName + ':changed', selectedValues);
                }, 100);
            },
            /**
             * Get the selected values, based on the checkboxes model
             * @return {Array}
             */
            getSelectedValues() {
                const values = [];

                $.each(this.selected, (value, status) => {
                    if (status === true) {
                        values.push(value);
                    }
                });

                return values;
            },
            /**
             * Get the selected values (as {value, label} objects), based on the checkboxes model
             * @return {Array}
             */
            getSelectedItemsFull() {
                const selectedValues = this.getSelectedValues();
                const selected = [];

                selectedValues.forEach(value => {
                    for (let i=0; i<this.selectableItems.length; i++) {
                        const selectableItem = this.selectableItems[i];
                        if (selectableItem.value === value) {
                            selected.push(selectableItem);
                            break;
                        }
                    }
                });

                return selected;
            },

            showPageFilterContent() {
                // This will prevent desktop to be able to hide the header
                if ($(window).width() > 768) {
                    return;
                }

                // Hides all headers
                $('.page-filter-header').hide();

                // Now shows the content
                this.isPageFilterContentVisible = true;

                this.$emit('show-specific-filter', this.id);
            },

            hidePageFilterContent() {

                this.isPageFilterContentVisible = false;

                $('.page-filter-header').show();

                this.$emit('show-all-filters');

            },

            /**
             * Callback for the search change event
             * @return {void}
             */
            searchUpdated() {
                this.showSpinner = false;

                const searchLength = $.trim(this.searchCity).length;

                // Searching needs a minimum amount of characters
                // Only update, if the search value is different from the previous
                if (searchLength >= 3 && this.searchCity !== this.previousSearchCity) {
                    this.previousSearchCity = this.searchCity;

                    $.getJSON('/ajax/cities', {s: this.searchCity})
                        .then(cities => {
                            return {
                                all: cities,
                                selected: [],
                            };
                        })
                        .then(this.formatCities)
                        .then(this.setSelectableCities);
                }

                // Revert to the nearby cities
                else if (searchLength === 0) {
                    this.setSelectableCities({
                        all: this.nearbyCities,
                    });
                }
            },

            emptySearchInput() {
              this.search = '';
            },
        },
    };
</script>



// WEBPACK FOOTER //
// resources/js/components/PageFilterMixin.vue